import React from 'react';
import 'react-day-picker/lib/style.css';
import Report from './ReportComponent';

const DobReport = () => <>
  <Report title='' dataSourceUrl='/api/dob?report' filter name='DOB'/>
</>;

export default DobReport;
